import { TextLink } from 'palette/TextLink';
import { BodyText, Header } from 'palette/Typography';
import { useTranslate } from '@common/Translations';
import { BEMBlock } from '@helpers/classnames';

import './RelatedListings.scss';

type RelatedListingsProps = {
    relatedListings: Array<{
        title: string;
        items: Array<{ name: string; url: string }>;
    }>;
};

export function RelatedListings({ relatedListings }: RelatedListingsProps) {
    const [block, element] = BEMBlock('related-listings');
    const translate = useTranslate();

    const numberOfColumns = relatedListings?.length || 1;

    return (
        <div className={block}>
            <div className={element('header-box')}>
                <Header
                    color="strong"
                    level="5"
                    tagName="h3"
                >
                    {translate('listing.related_listings.header')}
                </Header>
            </div>
            <div className={element('content', { [`${numberOfColumns}-columns`]: true })}>
                {
                    relatedListings?.map(({ title, items }) => (
                        <div key={title}>
                            <BodyText
                                className={element('subtitle')}
                                color="strong"
                                level="1"
                                tagName="h4"
                                weight="bold"
                            >
                                {title}
                            </BodyText>
                            {
                                items?.map(({ name, url }) => (
                                    <TextLink
                                        key={url}
                                        isUnderlinedOnHover
                                        href={url}
                                    >
                                        <BodyText
                                            className={element('link-text')}
                                            color="strong"
                                            level="2"
                                            tagName="p"
                                        >
                                            {name}
                                        </BodyText>
                                    </TextLink>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        </div>
    );
}
